/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { OidcService } from '../../types/oidc-service'
import Claims from '../../types/claims'
import { BaseOidcService } from '../base-oidc/base-oidc-service'

export type ProxyEvent = {
  messageType: string
}

export class ProxyOidcService extends BaseOidcService implements OidcService {
  private readonly WRAPPER_APP_CLIENT_ID = 'unifiedfrontend'

  public init = async (): Promise<void> => {
    return Promise.resolve()
  }

  public isAuthenticated = (): boolean => {
    return this.getAuthSession() != null
  }

  public checkSession = async (): Promise<boolean> => {
    // auth session relevance should be controlled by the wrapper app
    return Promise.resolve(true);
  }

  public getAccessToken = async (): Promise<string | null> => {
    const authSession = this.getAuthSession()
    return Promise.resolve(authSession?.access_token)
  }

  public getClaims = async (): Promise<Claims> => {
    const authSession = this.getAuthSession()
    const claims = authSession ? this.mapClaims(authSession.profile) : null
    return claims ? Promise.resolve(claims) : Promise.reject('No claims found')
  }

  public signinRedirect = async (): Promise<void> => {
    this.sendProxyEvent({ messageType: 'unauthorized' })
  }

  public signinRedirectCallback = (): Promise<void> => {
    // proxy flow has no signin redirect callback
    throw new Error("The method is not implemented.");
  }

  public logout = async (): Promise<void> => {
    if (this.logoutHandler)
      this.logoutHandler()

    this.sendProxyEvent({ messageType: 'logout' })
  }

  public onLogout(handler: () => void) {
    this.logoutHandler = handler
  }

  private getAuthSession = (): any | null => {
    const key = Object.keys(localStorage).find(key => 
      key.includes('oidc.user:') && key.includes(this.WRAPPER_APP_CLIENT_ID))
    return key ? JSON.parse(localStorage.getItem(key) as string) : null
  }

  private sendProxyEvent = (event: ProxyEvent): void => {
    const inIframe = window.self !== window.top

    inIframe
      ? window.parent.postMessage({ name: event.messageType, ...event }, "*")
      : console.error(`Cannot send '${event.messageType}' message to parent window. 
        \nParent Window Exists: ${inIframe}.`)
  }
}
